var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("div", { staticClass: "mb10" }),
        _c(
          "div",
          [
            _c(
              "vxe-table",
              {
                attrs: {
                  "row-id": "id",
                  data: _vm.table,
                  align: "left",
                  "row-style": _vm.setRowClass,
                },
              },
              [
                _c("vxe-table-column", {
                  attrs: {
                    field: "level",
                    "show-overflow": "",
                    "min-width": "120",
                    title: "日志等级",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "product_key",
                    "show-overflow": "",
                    "min-width": "120",
                    title: "产品Key",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "device_key",
                    "show-overflow": "",
                    "min-width": "120",
                    title: "设备Key",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "result",
                    "show-overflow": "",
                    "min-width": "80",
                    title: "上报结果",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "message",
                    "show-overflow": "",
                    "min-width": "220",
                    title: "信息",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "record_time",
                    "show-overflow": "",
                    "min-width": "120",
                    title: "时间",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "file_name",
                    "show-overflow": "",
                    "min-width": "120",
                    title: "文件名称",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.total
          ? _c("v-pagination", {
              attrs: {
                total: _vm.total,
                name: "page-basic",
                "is-show-total": "",
                "is-change-size": "",
                "is-input-page": "",
                "current-page": this.currentPage,
              },
              on: {
                "change-page": _vm.changePage,
                "change-size": _vm.changeSize,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }